// TL-inhouse（当社の版・2026-10-21 Shopify開発・要望 13）：HB の assets/tl-recently-viewed.js の写しに 2 点だけ足した物。
// (1) 欄が画面に近づいてから取りに行く (2) 出す数に足りるまで少しずつ取る。記録の仕方・見た目・データの形は元のまま。
// 2026-10-25：HB の 10/21 夜以降の版（売り場〔catalogSegment〕で絞る 2 行）を写し直した。
(() => {
  const STORAGE_KEY = 'tl_recently_viewed_v1';
  const RETENTION_DAYS = 90;
  const RETENTION_MS = RETENTION_DAYS * 24 * 60 * 60 * 1000;
  const MAX_STORED_PRODUCTS = 50;
  const cardRequests = new Map();
  let currentProductRecorded = false;

  const readHistory = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(stored)) return [];
      const cutoff = Date.now() - RETENTION_MS;
      const handles = new Set();
      return stored.filter((entry) => {
        if (!entry || typeof entry.handle !== 'string' || Number(entry.viewedAt) < cutoff || handles.has(entry.handle)) return false;
        handles.add(entry.handle);
        return true;
      }).slice(0, MAX_STORED_PRODUCTS);
    } catch (_error) {
      return [];
    }
  };

  const writeHistory = (history) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(0, MAX_STORED_PRODUCTS)));
    } catch (_error) {
      // Storage can be unavailable in private browsing or when the browser quota is full.
    }
  };

  const recordCurrentProduct = () => {
    if (currentProductRecorded) return;
    const handle = document.body.dataset.tlProductHandle;
    if (!handle || handle === 'alteration-service') return;
    currentProductRecorded = true;
    const history = readHistory().filter((entry) => entry.handle !== handle);
    history.unshift({ handle, viewedAt: Date.now() });
    writeHistory(history);
  };

  const fetchProductCard = (handle) => {
    if (!cardRequests.has(handle)) {
      const rootPath = window.routes?.root_url || '/';
      const path = `${rootPath.replace(/\/?$/, '/')}products/${encodeURIComponent(handle)}?section_id=tl-product-card-render`;
      cardRequests.set(handle, fetch(path, { credentials: 'same-origin' }).then(async (response) => {
        if (!response.ok) throw new Error(`Product card request failed: ${response.status}`);
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const card = documentFragment.querySelector('.tl-product-card');
        if (!card) throw new Error('Product card markup not found');
        return card;
      }));
    }
    return cardRequests.get(handle).then((card) => card.cloneNode(true));
  };

  const renderSection = async (root) => {
    if (root.dataset.tlHistoryReady === 'true') return;
    root.dataset.tlHistoryReady = 'true';
    const container = root.querySelector('[data-tl-history-items]');
    if (!container) return;

    const currentHandle = root.dataset.currentHandle || '';
    const limit = Math.max(1, Number(root.dataset.limit) || 6);
    const entries = readHistory().filter((entry) => entry.handle !== currentHandle);
    if (!entries.length) {
      root.hidden = true;
      return;
    }

    // TL-inhouse：出す数（limit）に足りるまで、新しい順に少しずつ取る（元は履歴の全件＝最大 50 件を一度に取っていた）
    const excludeSoldOut = root.dataset.excludeSoldOut !== 'false';
    const catalogSegment = root.dataset.catalogSegment;
    const batchSize = limit + 2;
    const cards = [];
    for (let i = 0; i < entries.length && cards.length < limit; i += batchSize) {
      const results = await Promise.allSettled(entries.slice(i, i + batchSize).map((entry) => fetchProductCard(entry.handle)));
      results.filter((result) => result.status === 'fulfilled').map((result) => result.value)
        .filter((card) => !catalogSegment || card.dataset.tlResultCatalog === catalogSegment)
        .filter((card) => !excludeSoldOut || !card.querySelector('.tl-badge-soldout'))
        .forEach((card) => { if (cards.length < limit) cards.push(card); });
    }
    if (!cards.length) {
      root.hidden = true;
      return;
    }

    const carousel = root.dataset.displayStyle === 'carousel';
    cards.forEach((card) => card.classList.toggle('tl-product-card--carousel', carousel));
    container.replaceChildren(...cards);
    const count = root.querySelector('[data-tl-history-count]');
    if (count) count.textContent = `${cards.length}商品`;
    root.hidden = false;
    document.dispatchEvent(new CustomEvent('tl:product-cards-rendered', { detail: { root } }));
  };

  // TL-inhouse：欄が画面に近づいてから取りに行く（商品ページでは欄がページの下の方＝開いた時の写真の読み込みとぶつけない）
  const whenNear = (root) => {
    if (!('IntersectionObserver' in window)) { renderSection(root); return; }
    const io = new IntersectionObserver((list) => {
      if (list.some((entry) => entry.isIntersecting)) { io.disconnect(); renderSection(root); }
    }, { rootMargin: '1200px 0px' });
    // 欄は最初 hidden（箱が無い）＝外側のセクションの枠（高さ 0 でも位置はある）で見る
    io.observe(root.closest('.shopify-section') || root.parentElement || root);
  };

  const initialize = (scope = document) => {
    recordCurrentProduct();
    scope.querySelectorAll('[data-tl-recently-viewed]').forEach(whenNear);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
